import React from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import wplTitle from '@assets/images/wpl/WPL-Title.svg'
import s1Image from '@assets/images/hil/s1.jpeg'
// import location from '@assets/images/hil/location.svg'
import people from '@assets/images/hil/people.svg'
import wplIcon from '@assets/images/wpl/wplLogo.svg'
import CustomLink from '@shared/components/customLink'
import PropTypes from 'prop-types'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import Image from 'next/future/image'

function WPLInfo({ info, venues }) {
  const venueCapacity = [
    { capacity: '20,111', imgUrl: 'media/attachments/1739179407056_Barboune.jpeg' },
    { capacity: '25,021', imgUrl: 'media/attachments/1739256225878_Stadium.jpeg' },
    { capacity: '30,711', imgUrl: 'media/attachments/1739179473915_Kotambi.jpeg' },
    { capacity: '34,238', imgUrl: 'media/attachments/1739179479069_Locknow.jpeg' }
  ]
  return (
    <>
      <div className={styles.leaguePointsTable}>
        <div className={`d-flex align-items-center ${styles.tableBanner}`}>
          <div className="d-flex gap-2 align-items-center">
            <MyImage alt="WPL Logo" className={styles.logo} src={wplIcon} />
            <Image alt="WPL Title" unoptimized={true} className={styles.logo} src={wplTitle} layout="raw" />
          </div>
        </div>
        <div className={styles.tableCntr}>
          {(info || [])?.map((item, index) => (
            <div key={index} className={styles.tableRow}>
              <div className={styles.tableLabel}>{item.sTitle}</div>
              <div className={item.label === 'Founded' ? styles.pinkValue : styles.tableValue}>{item.sValue}</div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h4 className="font-bold">Venues</h4>
        <div className={styles.venueContainer}>
          {(venues || [])?.map((venue, i) => {
            const capacity = venueCapacity[i % venueCapacity.length]?.capacity
            const imgUrl = `${S3_PREFIX}${venueCapacity[i % venueCapacity.length]?.imgUrl}`
            return (
              <div className="w-100 d-flex justify-content-between align-item-center gap-2" key={i}>
                <div className="w-75">
                  <MyImage alt="Stadium Image" src={imgUrl || s1Image} height={90} width={123} className={styles.stadiumImage} />
                </div>
                <div className="w-100">
                  <CustomLink href={venue?.oSeo?.sSlug}>
                    <a>
                      <div className={`${styles.stadiumTitle}`}>{venue?.sName || ''}</div>
                    </a>
                  </CustomLink>
                  <div className="d-flex justify-content-center gap-2 mt-2">
                    <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                      {/* <MyImage src={location} alt="Location" className={styles.loImg} /> */}
                      <p className="mb-0">{venue?.sLocation || ''}</p>
                    </div>
                    <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                      <MyImage alt="People" src={people} className={styles.loImg} />
                      <p className="mb-0">{capacity}</p>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}

WPLInfo.propTypes = {
  info: PropTypes.array,
  venues: PropTypes.array
}

export default WPLInfo
